import { createServerFn } from "@tanstack/react-start";
import { requireSupabaseAuth } from "@/integrations/supabase/auth-middleware";

export const getCurrentAdminRoles = createServerFn({ method: "GET" })
  .middleware([requireSupabaseAuth])
  .handler(async ({ context }) => {
    const { supabaseAdmin } = await import("@/integrations/supabase/client.server");
    const { data, error } = await supabaseAdmin
      .from("user_roles")
      .select("role")
      .eq("user_id", context.userId)
      .in("role", ["staff", "admin", "super_admin"]);

    if (error) throw error;

    const roles = (data ?? [])
      .map((row) => row.role)
      .filter((role) => role === "staff" || role === "admin" || role === "super_admin");

    return { roles };
  });